import type { FiQuestionnaireSystemTaskData, MinifiedTask } from '@gcv/shared';
import { TaskInternalType, TaskStatus } from '@gcv/shared';

const PENDING_TASK_STATUSES = new Set<TaskStatus>([TaskStatus.OPEN, TaskStatus.PROCESSING]);

const getResultId = (task: MinifiedTask) =>
  (task.data as FiQuestionnaireSystemTaskData)?.questionnaire_fi?.template_result_id;

// A revision adds a second task alongside the completed one; keyed by the result id both carry, latest wins.
export const getPendingRevisionTasks = (tasks: MinifiedTask[] | undefined): Map<string, MinifiedTask> => {
  const byResultId = new Map<string, MinifiedTask>();

  (tasks ?? [])
    .filter(
      (task) =>
        task.internal_type === TaskInternalType.REVISE_QUESTIONNAIRE && PENDING_TASK_STATUSES.has(task.status)
    )
    .sort((a, b) => (a.date_created ?? '').localeCompare(b.date_created ?? ''))
    .forEach((task) => {
      const resultId = getResultId(task);
      if (resultId) byResultId.set(resultId, task);
    });

  return byResultId;
};
